/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_Hop_Su_Go_Kim_TuyenInputs */

const vi_shop_product_type_hop_su_go_kim_tuyen = /** @type {(inputs: Shop_Product_Type_Hop_Su_Go_Kim_TuyenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộp sứ / gỗ / kim tuyến`)
};

/**

* @param {Shop_Product_Type_Hop_Su_Go_Kim_TuyenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_hop_su_go_kim_tuyen = /** @type {((inputs?: Shop_Product_Type_Hop_Su_Go_Kim_TuyenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_Hop_Su_Go_Kim_TuyenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_hop_su_go_kim_tuyen(inputs)
});